// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {CONFIG} from '@src/environments/app.config';
export const environment = {
  production: false,
  theme:'template2',
  apiUrl: CONFIG.apiUrl,
  workItemsApi: CONFIG.workItemsApi,
  scraperApi: CONFIG.scraperApi,
  clientId: CONFIG.clientId,
  mlApi: CONFIG.mlApi,
  ssoApi: CONFIG.ssoApi,
  domainName: CONFIG.appWebDomain,
  automationAppUrl: CONFIG.automationAppUrl,
  redirectSignInUrl: CONFIG.redirectSignInUrl,
  redirectSignOutUrl: CONFIG.redirectSignOutUrl,
  publishingApi: CONFIG.publishingApi,
  onDemadHtml: true,
  exchangeMap: {
    'NASDAQ':'XNAS',
    'NYSE':'XNYS',
    'NYSE MKT':'XASE',
    'OTC':'OTCM',
    'TSX':'XTSE',
    'TSXV':'XTSX',
    'LSE':'XLON',
    'FWB':'XFRA',
    'ENP':'XPAR',
    'BIT':'XMIL',
    'MOEX':'MISX',
    'TSE':'XJPX',
    'BRZ':'BVMF',
    'SSE':'XSHG',
    'SZSE':'XSHE',
    'BSE':'XBOM',
    'NSE':'XNSE',
    'HKEX':'XHKG',
    'SGX':'XSES',
    'ASX':'XASX',
    'BMV':'XMEX',
    'JSE':'XJSE',
    'SWX':'XSWX',
    'ISE':'XDUB',
    'AEX':'XAMS',
    'SMX':'XSTO'
     },
    queues_info: {
    'CURRENT_POOL':'data-aggregation-current-pool',
    'HISTORICAL_POOL': 'data-aggregation-historical-pool',
    'DATA_SOURCE_URL_FAILED': 'data-source-url-failed',
    'DATA_SOURCE_VALIDATE_PREDICTION': 'data-source-validate-prediction',
    'DAGGR_VERIFY_COMPANY_ACTIONS': 'daggr-verify-company-actions',
    'MANUAL_DATASOURCE':'manual-datasource',
    'MANUAL_PRIORITY':'manual-priority',
    },
  button_disable_time_range: {
    'fromTime' : '06:15 AM',
    'toTime' : '07:00 AM',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
